import './form-locale.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSFormLocaleCountries } from './form-locale-countries';
import { GSFormLocaleChangePrompt } from './form-locale-change-prompt';

components.register({
	selector: '.gs-FormLocale',
	controller: GSFormLocaleCountries
});

components.register({
	selector: '.gs-FormLocale-changePrompt',
	controller: GSFormLocaleChangePrompt
});

